import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleryPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import NavIcon from "./components/UI/NavIcon";
import MobileNavigation from "./components/Navigation/MobileNavigation";
import { useLocation } from 'react-router-dom'

const App = () => {
  const [openNav, setOpenNav] = useState(false)

  const location = useLocation();
  useEffect(() => {
    setOpenNav(false)
  }, [location])

  const openNavHandler = () => {
    setOpenNav(true)
  }
  const closeNavHandler = () => {
    setOpenNav(false)
  }
  return (
    <>
      <Header />
      <NavIcon onClick={openNavHandler} />
      {openNav && <MobileNavigation onClick={closeNavHandler} />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="contact" element={<ContactUsPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default App;
